export const DEBUG = true

// Docker stand (and CRA opened as localhost): talk to the same origin so
// /frontend/ is served by the local Apache, not lab/prod.
// DEBUG keeps the stage host (lab) even when the page is opened on localhost.
const isLocalStand = !DEBUG && typeof window !== 'undefined'
    && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')

// CRA on :3000 is not the API. Always prefer the docker HTTPS vhost (:8443):
// plain HTTP to that port yields Apache "400 Bad Request" (see access log
// as `GET / HTTP/1.0`). When the page itself is already on :8443/:8080,
// reuse that origin so cookies stay same-site.
const localOrigin = (() => {
    if (!isLocalStand) return ''
    const port = String(window.location.port || '')
    if (port === '3000' || port === '') {
        return `https://${window.location.hostname}:8443`
    }
    return window.location.origin
})()

export const base_url_stage = isLocalStand ? `${localOrigin}/frontend/` : 'https://lab.scladro.ru/frontend/'
export const base_url_prod = isLocalStand ? `${localOrigin}/frontend/` : 'https://l.scladro.ru/frontend/'

export const url_stage = isLocalStand ? localOrigin : 'https://lab.scladro.ru'
export const url_prod = isLocalStand ? localOrigin : 'https://l.scladro.ru'

export const currency_char = '₽';
export const orangeBackground = {
    backgroundImage: 'linear-gradient(135deg, #ffb73d, #ffa000)'
};

export const greenBackground = {
    backgroundImage: 'linear-gradient(135deg, green, lightgreen)'
};
export const min_auth_version = "1.1.3";

export const YMAPS_API_KEY =  "8a694fcf-31d2-4b73-88bd-f77ad37130c4";


export const blocked_groups = [
/*    {
        external_id: "4f61e9e4-7e77-11f0-8b63-d85ed34e181e_group",
        sclads: [
            {"external_id": "7a8e509d-a2e4-11ed-9915-dcf401e4eb09",
                "message": "Товар по складу пока только на просмотр до 27.10.2025 - идет инвентаризация"}
        ]
    },
    {
        external_id: "91c660c7-27eb-11ef-8b51-d85ed34e181e_group",
        sclads: [
            {"external_id": "7a8e509d-a2e4-11ed-9915-dcf401e4eb09",
                "message": "Товар по складу пока только на просмотр до 27.10.2025 - идет инвентаризация"}
        ]
    },
    {
        external_id: "91c660cb-27eb-11ef-8b51-d85ed34e181e_group",
        sclads: [
            {"external_id": "7a8e509d-a2e4-11ed-9915-dcf401e4eb09",
                "message": "Товар по складу пока только на просмотр до 27.10.2025 - идет инвентаризация"}
        ]
    },
    {
        external_id: "91c660cf-27eb-11ef-8b51-d85ed34e181e_group",
        sclads: [
            {"external_id": "7a8e509d-a2e4-11ed-9915-dcf401e4eb09",
                "message": "Товар по складу пока только на просмотр до 27.10.2025 - идет инвентаризация"}
        ]
    },
    {
        external_id: "e138353b-1cea-11ef-8b50-d85ed34e181e_group",
        sclads: [
            {"external_id": "7a8e509d-a2e4-11ed-9915-dcf401e4eb09",
                "message": "Товар по складу пока только на просмотр до 27.10.2025 - идет инвентаризация"}
        ]
    },
    {
        external_id: "e1383543-1cea-11ef-8b50-d85ed34e181e_group",
        sclads: [
            {"external_id": "7a8e509d-a2e4-11ed-9915-dcf401e4eb09",
                "message": "Товар по складу пока только на просмотр до 27.10.2025 - идет инвентаризация"}
        ]
    },*/
]







export const EMPTY_INN = '00000000000';
export const MODAL_SEND_EMAILS = "modal_send_emails";
export const MODAL_INCOMINGS_INFO = "modal_incomings_info";
export const MODAL_SEARCH_KLIENT_BY_PHONE = "search_klient_by_phone";
export const MODAL_MAIN_MENU = "main_menu";
export const MODAL_SEND_ORDER = "send_order";
export const MODAL_SEND_MONITORING = "send_monitoring";
export const MODAL_CHECK_MODS = "check_mods";
export const MODAL_LIST_OBJECTS = "list_objects";
export const MODAL_SELECT_LIST = "select_list";
export const MODAL_SELECT_LIST_ADD = "select_list_add";
export const MODAL_TAKE_A_PHOTO = "take_a_photo";
export const MODAL_TAKE_A_VIDEO = "take_a_video";
export const MODAL_DISCOUNT = "discount";
export const MODAL_SCISSORS = "scissors";
export const MODAL_ADDITIONAL_PRODUCTS = "additional_products";
export const MODAL_PARAMS_LIST = "params_list";
export const MODAL_SERIES_ORDER = "series_order";
export const MODAL_PATH_DOCS = "path_docs";
export const MODAL_RESERVES = "reserves";
export const MODAL_PARAMS_FILTER = "params_filter";
export const MODAL_GET_PHONE = "modal_get_phone";
export const MODAL_FIRM_FIT_DOCS = "modal_firm_fit_docs";
export const MODAL_CART_ITEM_COMMENT = "modal_cart_item_comment";
export const MODAL_SERIES = "series";
export const MODAL_EDIT_SALE_POINT = "modal_edit_sale_point";
export const MODAL_STANDS_SHARE = "stands_share";
export const MODAL_CITY_STANDS_SHARE = "city_stands_share";


export const EMPTY_IMG = "/assets2/img/empty.jpg"


export const CODE_INCOMING_STATUS_NEW = 0
export const CODE_INCOMING_STATUS_IN_PROCESS = 1
export const CODE_INCOMING_STATUS_SENT = 2



export const CODE_FACING_MONITORING_STATUS_NEW = 0
export const CODE_FACING_MONITORING_STATUS_IN_PROCESS = 1
export const CODE_FACING_MONITORING_STATUS_END = 2


export const CODE_SALE_POINT_MONITORING_STATUS_DRAFT = -1
export const CODE_SALE_POINT_MONITORING_STATUS_OFFLINE = -2
export const CODE_SALE_POINT_MONITORING_STATUS_NEW = 0
export const CODE_SALE_POINT_MONITORING_STATUS_IN_PROCESS = 1
export const CODE_SALE_POINT_MONITORING_STATUS_END = 2


export const CODE_FACING_MONITORING_TYPE_FULL = 'full'
export const CODE_FACING_MONITORING_TYPE_PART = 'part'


export const CODE_EQUIPMENT_GROUP_KERAMIKA = '2'
export const CODE_EQUIPMENT_GROUP_NAPOLKA = '1'

export const EMPTY_LINK = '00000000-0000-0000-0000-000000000000'
export const keyEmpty = '00000000-0000-0000-0000-000000000000'
export const keyBase = '00000000-0000-0000-0000-000000000002'
export const keyUnique = '00000000-0000-0000-0000-000000000001'

export const current_theme_key = "current_theme";
export const equipment_types_cache_key = "equipment_types_cache";
export const sale_point_types_cache_key = "sale_point_types_cache";
export const image_angles_cache_key = "image_angles_cache_3";
export const trademarks_cache_key = "trademarks_cache_2";
export const rec_sclads_cache_key = "rec_sclads_cache";
export const divisions_cache_key = "divisions_cache";
export const staff_positions_cache_key = "staff_positions_cache";
// v2: invalidate stale offline schema that could contain duplicate seed questions
export const monitoring_questions_cache_key = "monitoring_questions_cache_v2";

// Ключи для timestamp последнего обновления кэша
export const equipment_types_last_update_key = "equipment_types_last_update";
export const sale_point_types_last_update_key = "sale_point_types_last_update";
export const image_angles_last_update_key = "image_angles_last_update_3";
export const trademarks_last_update_key = "trademarks_last_update";
export const rec_sclads_last_update_key = "rec_sclads_last_update";
export const divisions_last_update_key = "divisions_last_update";
export const staff_positions_last_update_key = "staff_positions_last_update";
export const monitoring_questions_last_update_key = "monitoring_questions_last_update_v2";

// Время жизни кэша типов - 30 минут
export const TYPES_CACHE_TTL_MS = 30 * 60 * 1000;
// Время жизни кэша rec_sclads и divisions - 3 часа
export const REC_SCLADS_DIVISIONS_CACHE_TTL_MS = 3 * 60 * 60 * 1000;

export const last_login_data_key = "last_login_data";
export const is_application_key = "is_application";
export const photo_defective_act_key = "photo_defective_act_2";
export const data_defective_act_key = "data_defective_act_2";
export const photo_incomings_key = "photo_incomings_2";

export const values_incomings_key = "values_incomings_2";

export const current_docs_incomings_key = "current_docs_incomings";


export const values_facing_monitoring_key = "values_facing_monitoring";
export const values_sale_point_monitoring_key = "values_sale_point_monitoring";
export const current_sale_point_monitoring_step_key = "current_sale_point_monitoring_step";
export const sale_point_monitoring_date_period_key = "sale_point_monitoring_date_period";

// export const photo_sale_point_monitoring_key = "photo_sale_point_monitoring";

export const current_facing_monitoring_type_key = "current_facing_monitoring_type";
export const current_facing_monitoring_division_key = "current_facing_monitoring_division";


export const menu_collapsed_key = "menu_collapsed";
export const photo_ffc_items_key = "photo_ffc_items2";
export const copy_to_clipboard_key = "copy_to_clipboard";
export const monitoring_items_key = "monitoring_items3";
export const current_phone_key = "current_phone";
export const search_history_key = "search_history3";
export const current_order_comment_key = "current_order_comment";
export const monarch_bonus_phone_key = "monarch_bonus_phone";
export const main_search_key = "main_search";
export const store_klients_items_key = "store_klients_items_key2";
export const last_store_klients_items_key = "last_store_klients_items_key";
export const current_subdivision_key = "current_subdivision";
export const rec_sclad_key = "rec_sclad";
export const CART_ID = "CART_ID";
export const STORAGE_ID = "STORAGE_ID";
export const USER_NAME = "USER_NAME";
export const PASSWORD = "PASSWORD";
const getWidth = () => window.innerWidth;
const getHeight = () => window.innerHeight;
const isMobile = (w) => w < 800;
export const longDateTimeFormat = 'MMMM Do YYYY, HH:mm:ss'
export const simpleDateTimeFormat = 'DD.MM.YYYY HH:mm'
export let AdaptivityContext = {
    w: getWidth(),
    h: getHeight(),
    isMobile: isMobile(getWidth()),
    copy_to_clipboard_enabled: false
};
export const formatBytes = (b, p = null) => {
    const units = ["B", "kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    if (b <= 0) return "0 B"; // Обрабатываем случай нуля

    if (p === null) {
        p = Math.floor(Math.log(b) / Math.log(1024)); // Вычисляем наилучшую единицу
    }

    p = Math.min(p, units.length - 1); // Ограничиваем индекс

    const value = b / Math.pow(1024, p);

    return (value % 1 === 0 ? value.toFixed(0) : value.toFixed(2)) + units[p];
}

String.prototype.rtrim = function (s) {
    return this.replace(new RegExp(s + "*$"), '');
};

/**
 * Возвращает сохранённое подразделение из localStorage.
 * Если передан current_user — дополнительно валидирует, что выбранное
 * подразделение всё ещё присутствует в его списке my_divisions.
 * При невалидном значении удаляет его из localStorage, чтобы не уходило в API.
 */
export const getSavedSubdivision = (current_user = null) => {
    const raw = localStorage.getItem(current_subdivision_key);
    if (!raw) return null;

    let parsed = null;
    try {
        parsed = JSON.parse(raw);
    } catch (e) {
        console.error('Error parsing saved subdivision:', e);
        localStorage.removeItem(current_subdivision_key);
        return null;
    }

    if (!parsed || !parsed.external_id) {
        localStorage.removeItem(current_subdivision_key);
        return null;
    }

    if (current_user) {
        const myDivisions = Array.isArray(current_user.my_divisions) ? current_user.my_divisions : [];
        const isValid = myDivisions.some(d => d && d.external_id === parsed.external_id);
        if (!isValid) {
            localStorage.removeItem(current_subdivision_key);
            return null;
        }
    }

    return parsed;
};

export const checkIsModer = (current_user) => {

    return current_user
        && current_user.meta
        && current_user.meta.settings
        && current_user.meta.settings.moderator_facing_monitoring
}

export const checkIsAdmin = (current_user) => {

    return current_user
        && current_user.meta
        && current_user.meta.rules
        && current_user.meta.rules.admin
}

export const checkCanMakeDocs = (current_user) =>
    current_user?.meta?.rules?.make_docs == '1'

export const checkCanViewCatalog = (current_user) =>
    current_user?.meta?.rules?.ostatki == '1'

export const checkCanViewOst2 = (current_user) =>
    current_user?.meta?.settings?.show_ost2 == '1'

export const canUseProductSearch = (current_user) => {
    const hideOst = current_user?.meta?.settings?.hide_ost == '1'
    return (checkCanViewCatalog(current_user) && !hideOst) || checkCanViewOst2(current_user)
}

export const TRADE_DESIGNER_POS_ID = 4
export const SYSTEM_STAFF_POSITION_IDS = [1, 2, 3, 4]
export const ACCESS_DENIED_MESSAGE = 'Недостаточно прав'
export const DESIGNER_FORBIDDEN_STORIES = [
    'sale_point_monitoring_story',
    'sale_point_map_story',
    'datalens_export_story',
    'klients_story',
    'stands_story',
    'standcollections_story',
    'stand_collection_bindings_story',
    'staff_story'
]

export const isTradeDesigner = (current_user) => {
    if (!current_user || current_user.position_id === undefined || current_user.position_id === null) {
        return false
    }

    return Number(current_user.position_id) === TRADE_DESIGNER_POS_ID
}

export const isDesignerForbiddenStory = (story) => {
    if (!story) {
        return false
    }

    const normalizedStory = String(story).endsWith('_story') ? String(story) : `${story}_story`
    return DESIGNER_FORBIDDEN_STORIES.includes(normalizedStory)
}

export const checkNarezkaForUral = (item) => {
    const {matrica_narezka, tip_tovara} = item
    let narezka = false
    if (matrica_narezka && matrica_narezka.value == 'матрица' &&
        tip_tovara && tip_tovara.value == 'ковролин,линолеум,трава,дорожки') {
        narezka = true
    }
    return narezka
}

export const getRulonUnit = (product) => {
    return (product.units || []).find(u => {
        if (!u.title) return false
        const t = u.title.toLowerCase()
        // в 1С единица может называться «рулон», «рул» и т.п.
        return t.indexOf('рулон') !== -1 || t === 'рул' || t.indexOf('рул') === 0
    }) || null
}
export const inducement = (c, one, two, five) => {

    c = Math.abs(c);
    c %= 100;
    if ((c >= 5) && (c <= 20)) {
        return five;
    }
    ;
    c %= 10;
    if (c == 1) {
        return one;
    }
    ;
    if ((c >= 2) && (c <= 4)) {
        return two;
    }
    ;
    return five;
}

export const userIsTradeChild = (current_user, user_id) => {
    let result = false;
    if (isTradeDesigner(current_user)) return false
    if (current_user && current_user.position_id == 3) return true

    if (current_user && current_user.childs_ids && Array.isArray(current_user.childs_ids)) {
        if (current_user.id === user_id) return true

        const ids = current_user.childs_ids.filter(id => id === user_id)

        result = ids.length > 0
    }
    return result
}
export const getFacingMonitoringStatuses = () => {
    const result = {}

    result[''] = 'Все статусы'
    result[CODE_FACING_MONITORING_STATUS_NEW] = 'Новый'
    result[CODE_FACING_MONITORING_STATUS_IN_PROCESS] = 'В работе'
    result[CODE_FACING_MONITORING_STATUS_END] = 'Завершен'

    return result
}
export const getSalePointMonitoringStatuses = () => {
    const result = {}

    result[''] = 'Все статусы'
    result[CODE_SALE_POINT_MONITORING_STATUS_NEW] = 'Новый'
    result[CODE_SALE_POINT_MONITORING_STATUS_IN_PROCESS] = 'В работе'
    result[CODE_SALE_POINT_MONITORING_STATUS_END] = 'Завершен'
    result[CODE_SALE_POINT_MONITORING_STATUS_DRAFT] = 'Черновик'
    result[CODE_SALE_POINT_MONITORING_STATUS_OFFLINE] = 'Offline'
    return result
}

export const getFacingMonitoringTypes = () => {
    const result = {}

    result[''] = 'Все типы'
    result[CODE_FACING_MONITORING_TYPE_FULL] = 'Полная'
    result[CODE_FACING_MONITORING_TYPE_PART] = 'Частичная'

    return result
}

export const getSalePointsTypes = () => {
    // Пытаемся получить из кэша
    const cached = localStorage.getItem(sale_point_types_cache_key);
    
    if (cached) {
        try {
            return JSON.parse(cached);
        } catch (e) {
            console.error('Ошибка парсинга типов торговых точек из кэша:', e);
        }
    }
    
    // Fallback на дефолтные значения если кэш пуст
    const result = {}
    result[''] = 'Не указан'


    return result
}

export const SELLER_QUALIFICATIONS = {
    0: 'Не указана',
    1: 'Стажёр',
    2: 'Новенький',
    3: 'Опытный',
    4: 'Профи',
}

export const DEFAULT_STAFF_POSITIONS = {
    1: 'Торговый представитель',
    2: 'Модератор мониторинга',
    3: 'Аналитик',
    4: 'Дизайнер',
    5: 'Продавец',
    6: 'Старший продавец',
    7: 'Управляющий',
    8: 'Кассир',
    9: 'Собственник',
    10: 'Руководитель',
}

export const getStaffPositions = () => {
    const cached = localStorage.getItem(staff_positions_cache_key);
    let fromCache = {};

    if (cached) {
        try {
            fromCache = JSON.parse(cached) || {};
        } catch (e) {
            console.error('Ошибка парсинга должностей из кэша:', e);
        }
    }

    return {
        0: 'Не указана',
        ...DEFAULT_STAFF_POSITIONS,
        ...fromCache,
    }
}

export const getTtStaffPositions = () => {
    const all = getStaffPositions()
    const result = {}
    Object.keys(all).forEach((key) => {
        const id = Number(key)
        if (!id || SYSTEM_STAFF_POSITION_IDS.indexOf(id) === -1) {
            result[key] = all[key]
        }
    })
    return result
}


export const getEquipmentTypes = () => {
    // Пытаемся получить из кэша
    const cached = localStorage.getItem(equipment_types_cache_key);
    
    if (cached) {
        try {
            return JSON.parse(cached);
        } catch (e) {
            console.error('Ошибка парсинга типов оборудования из кэша:', e);
        }
    }
    
    // Fallback на дефолтные значения если кэш пуст
    const result = {}

    result[0] = 'Не указан'


    // Сортируем результат в алфавитном порядке по значениям
    // Сохраняем 'Не указан' на первом месте
    const sortedEntries = Object.entries(result).sort((a, b) => {
        // Ключ 0 всегда остается первым
        if (a[0] == 0) return -1
        if (b[0] == 0) return 1
        // Остальные сортируем по алфавиту (значениям)
        return a[1].localeCompare(b[1], 'ru')
    })

    const sortedResult = {}
    sortedEntries.forEach(([key, value]) => {
        sortedResult[key] = value
    })

    return sortedResult
}

export const getImageAngles = () => {
    // Пытаемся получить из кэша
    const cached = localStorage.getItem(image_angles_cache_key);
    
    if (cached) {
        try {
            return JSON.parse(cached);
        } catch (e) {
            console.error('Ошибка парсинга ракурсов изображений из кэша:', e);
        }
    }
    
    // Fallback на дефолтные значения если кэш пуст
    const result = {}


    return result
}

export const getTrademarks = () => {
    // Пытаемся получить из кэша
    const cached = localStorage.getItem(trademarks_cache_key);
    
    if (cached) {
        try {
            return JSON.parse(cached);
        } catch (e) {
            console.error('Ошибка парсинга торговых марок из кэша:', e);
        }
    }
    
    // Fallback на дефолтные значения если кэш пуст
    const result = {}
    result[''] = 'Не указана'

    return result
}

export const getEquipmentGroups = () => {
    const result = {}

    result[0] = 'Не указан'
    result[CODE_EQUIPMENT_GROUP_NAPOLKA] = 'Напольные покрытия'
    result[CODE_EQUIPMENT_GROUP_KERAMIKA] = 'Керамика'

    return result
}

/**
 * Drop accidental duplicate questions (same type + title), keep lowest id.
 * @param {Array} questions
 * @returns {Array}
 */
export const dedupeMonitoringQuestions = (questions) => {
    if (!Array.isArray(questions) || questions.length === 0) {
        return [];
    }
    const sorted = [...questions].sort((a, b) => Number(a.id) - Number(b.id));
    const seen = new Set();
    const result = [];
    sorted.forEach(q => {
        if (!q) return;
        const key = `${q.type || ''}|${String(q.title || '').trim()}`;
        if (seen.has(key)) return;
        seen.add(key);
        result.push(q);
    });
    return result;
}

/**
 * Схема опросника мониторинга ТТ из localStorage (offline).
 * @returns {{questions: Array, tree: Array, qualifications: Object}}
 */
export const getMonitoringQuestions = () => {
    const cached = localStorage.getItem(monitoring_questions_cache_key);
    if (cached) {
        try {
            const parsed = JSON.parse(cached);
            return {
                questions: dedupeMonitoringQuestions(parsed.questions || []),
                tree: parsed.tree || [],
                qualifications: parsed.qualifications || {},
            };
        } catch (e) {
            console.error('Ошибка парсинга опросника мониторинга из кэша:', e);
        }
    }
    return {questions: [], tree: [], qualifications: {}};
}

export const getGUID = () => {

    let d = new Date().getTime();//Timestamp
    let d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16;//random number between 0 and 16
        if (d > 0) {//Use timestamp until depleted
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {//Use microseconds since page-load if supported
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });

}

export  const formatDateTime = (date, withTime = false) => {

    if(!date){
        date = new Date()
    }
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // месяцы начинаются с 0
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return withTime ? `${day}.${month}.${year} ${hours}:${minutes}:${seconds}` : `${day}.${month}.${year}`;
}


export const setQuizStep = (number, objectName) => {
    setTimeout(() =>
            window.postMessage({type: 'setStep', numStep: number, objectName: objectName})
        , 200)
}
export const countDecimalPlaces = (number) => {
    if (Math.floor(number) === number * 1) {
        return 0
    }
    let nstring = number.toString()
    if (nstring.indexOf('.') !== -1) {
        nstring.rtrim('0')
    }

    return nstring.split('.')[1].length || 0
}

export const formatQnt = (number, zeroToEmptyString = false, numAfterDot = 3) => {
    let result = number;

    result = (result * 1).toFixed(numAfterDot).replace('.000', '').replace('.00', '')
    if (result.toString().indexOf('.') != -1) {
        while (result.endsWith('0')) {
            result = result.substring(0, result.length - 1)
        }
    }
    if (!zeroToEmptyString) {
        return result;
    } else {
        return result * 1 ? result : '';
    }
}

export const checkGroupBlocked = (path, scladExternalId) => {

    for (const pathItem of path) {

        const blockedGroup = blocked_groups.find(bg => bg.external_id == pathItem.external_id);

        if (blockedGroup) {

            const blockedSclad = blockedGroup.sclads.find(s => s.external_id == scladExternalId);

            if (blockedSclad) {

                return blockedSclad.message;
            }
        }
    }
    return false;
}

/**
 * Проверяет заблокирован ли товар из-за инвентаризации
 * @param {Object} inventoryData - Данные инвентаризации от API /?app=inventory&act=getList
 * @param {string} scladExternalId - ID склада
 * @param {number} product_id - ID товара
 * @returns {string|null} Сообщение о блокировке или null если товар не заблокирован
 *
 * Пример использования:
 * const response = await BaseApi.get('/?app=inventory&act=getList');
 * const message = checkProductBlocked(response.data, "7a8e509d-a2e4-11ed-9915-dcf401e4eb09", 993231);
 */
export const checkProductBlocked = (inventoryData, scladExternalId, product_id) => {
    
    if (!inventoryData || !Array.isArray(inventoryData.results)) {
        return null;
    }

    // Находим все инвентаризации по складу
    const inventories = inventoryData.results.filter(inv => inv.sclad_external_id === scladExternalId);
    
    if (!inventories.length) {
        return null;
    }

    // Проверяем, в каких инвентаризациях есть товар
    const matchedInventories = inventories.filter(inv =>
        Array.isArray(inv.products) && inv.products.some(p => p.product_id == product_id)
    );
    
    if (!matchedInventories.length) {
        return null;
    }

    const latestInventory = matchedInventories.reduce((latest, current) => {
        const latestEndDate = Number(latest.end_date) || 0;
        const currentEndDate = Number(current.end_date) || 0;
        return currentEndDate > latestEndDate ? current : latest;
    }, matchedInventories[0]);

    const inventoriesNumbers = [...new Set(matchedInventories.map(inv => inv.number).filter(Boolean))];
    const inventoriesLabel = inventoriesNumbers.length ? inventoriesNumbers.join(', ') : String(latestInventory.id);

    // Возвращаем сообщение с датой окончания инвентаризации
    return `Товар по складу пока только на просмотр до ${latestInventory.end_date_formatted} - идет инвентаризация ${inventoriesLabel}`;
}

/**
 * Асинхронная версия проверки блокировки товара - получает данные инвентаризации и проверяет блокировку
 * @param {Function} getInventoryDataFn - Функция для получения данных инвентаризации
 * @param {string} scladExternalId - ID склада
 * @param {number} product_id - ID товара
 * @returns {Promise<string|null>} Сообщение о блокировке или null если товар не заблокирован
 *
 * Пример использования:
 * const message = await checkProductBlockedAsync(
 *     () => BaseApi.get('/?app=inventory&act=getList'),
 *     "7a8e509d-a2e4-11ed-9915-dcf401e4eb09",
 *     993231
 * );
 */
export const checkProductBlockedAsync = async (getInventoryDataFn, scladExternalId, product_id) => {
    try {
        // Получаем данные инвентаризации через переданную функцию
        const response = await getInventoryDataFn();
        const inventoryData = response.data;
        
        // Используем синхронную версию функции
        return checkProductBlocked(inventoryData, scladExternalId, product_id);
    } catch (error) {
        console.error('Ошибка при получении данных инвентаризации:', error);
        return null;
    }
}

/**
 * Причина блокировки заказа товара.
 * Приоритет: авторитетный ответ бэкенда `product.order_block` (getProduct).
 * Если бэкенд его ещё не прислал - деградируем на старый расчёт по read_only/is_primavera + клубы пользователя.
 * @param {Object} product
 * @param {Object} user
 * @returns {{blocked: boolean, reason_code: string|null, reason_text: string|null}}
 */
export const getProductOrderBlock = (product, user) => {
    if (product && product.order_block && typeof product.order_block === 'object') {
        return product.order_block
    }

    const readOnly = !!(product && (product.read_only == '1' || product.read_only === true))
    const settings = user && user.meta && user.meta.settings
    const primaveraBlocked = !!(product
        && (!product.is_firm_fit || product.is_firm_fit == '0')
        && product.is_primavera == '1'
        && !(settings && settings.primavera_club == '1'))

    return {
        blocked: readOnly || primaveraBlocked,
        reason_code: null,
        reason_text: readOnly
            ? 'Склад доступен только на просмотр в соответствии с правилами контроля доступности брендов, обратитесь к администратору'
            : (primaveraBlocked ? 'Для заказа требуется участие в программе Primavera Club' : null)
    }
}

/**
 * Причина блокировки заказа конкретного склада.
 * Приоритет: авторитетный ответ бэкенда `block_reason` (getSclads, for_api=1).
 * Если бэкенд его ещё не прислал - деградируем на старую проверку disabled/dont_order.
 * @param {Object} sclad
 * @returns {{blocked: boolean, reason_code: string|null, reason_text: string|null}}
 */
export const getScladBlockReason = (sclad) => {
    if (sclad && sclad.block_reason && typeof sclad.block_reason === 'object') {
        return sclad.block_reason
    }

    const blocked = !!(sclad && (sclad.disabled == '1' || sclad.dont_order == '1' || sclad.dont_order === true))

    return {
        blocked,
        reason_code: null,
        reason_text: blocked ? 'Этот склад доступен только для просмотра' : null
    }
}

export const ORDER_BLOCK_MANAGER_SUFFIX = '. Обратитесь к своему менеджеру в компании Монарх'

export const formatOrderBlockHelpText = (reasonText) => {
    if (!reasonText) {
        return null
    }
    return reasonText + ORDER_BLOCK_MANAGER_SUFFIX
}
